export const TYPEFORM_URL = "https://example.com/replace-with-your-typeform";
export const PLAYBOOK_URL =
  "https://example.com/replace-with-your-playbook-pdf";

export const BRAND = {
  name: "SmartUp360",
  positioning:
    "SmartUp360: The operating system for the next generation of African Producers.",
};

export const WAITLIST_FLAG_KEY = "smartup_waitlist_submitted";

export const CTA_SOURCES = {
  hero_primary: "hero_primary",
  hero_secondary: "hero_secondary",
  pillars_cta: "pillars_cta",
  success_gate: "success_gate",
};

export const WHATSAPP_NUMBER_E164 = "+2348062543368"; // replace
export const WHATSAPP_DEFAULT_TEXT =
  "Hi SmartUp360, I want to learn more about the Global Showcase and the 2026 platform waitlist.";

export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/smartup360?igsh=MXhseHFqcjNnMDUzOQ==",
  facebook: "https://web.facebook.com/profile.php?id=100069641379172",
  x: "https://x.com/smartup360",
  linkedin: "https://linkedin.com/company/smartup360",
};
